import { AbstractApi } from './abstract-api.js';

export interface FeatureApi {
  markSeen(baseEndpoint: string, featureKey: string): Promise<boolean>;
}

class FeatureApiClass extends AbstractApi implements FeatureApi {
  async markSeen(baseEndpoint: string, featureKey: string): Promise<boolean> {
    return this.post(`${baseEndpoint}${featureKey}/seen`, 'FeatureSeen', {});
  }
}

export const FeatureApiInstance: FeatureApi = new FeatureApiClass();
